import { getCampaigns } from '@rmc/webcx-web-libs';
import { useQuery } from '@tanstack/react-query';
import {
	VERSION,
	API_MAIN_ENDPOINT,
	API_URL_WEBCX,
} from '../../../../../config';
import { getError } from '../../../../getError';

type CampaignsType = {
	id: string;
	visit: number;
}[];

type BlocksApiCreateType = {
	campaigns: CampaignsType;
	device: string;
	clientId: string;
	sessionId: string;
	domainScopedSessionId: string;
	userId: string;
	previewQuery?: object;
};

export function useBlocksApiPost({
	campaigns,
	clientId = '',
	sessionId = '',
	domainScopedSessionId = '',
	userId = '',
	device = '',
	previewQuery = {},
}: BlocksApiCreateType) {
	const isPreview = Object.keys(previewQuery).length !== 0;
	const isClientId = !!clientId;
	const isCampaignLength = campaigns.length > 0;
	const isPreviewAllowed = isPreview && isClientId;
	const isNormalReqAllowed = isCampaignLength && isClientId;

	return useQuery({
		queryFn: async () => {
			try {
				const { data } = await getCampaigns({
					device,
					userId,
					sessionId,
					domainScopedSessionId,
					previewQuery,
					campaigns,
					clientId,
					apiUrlConfig: API_URL_WEBCX,
					endpoint: API_MAIN_ENDPOINT,
					version: VERSION,
				});

				return Array.isArray(data) ? data : [data];
			} catch (e) {
				throw getError(e);
			}
		},
		queryKey: ['blocksList', isPreviewAllowed, isNormalReqAllowed],
		enabled: isPreviewAllowed || isNormalReqAllowed,
		retry: false,
		refetchOnWindowFocus: false,
	});
}
